import { queryOptions } from "@tanstack/react-query";
import { getClassesOverview } from "#/modules/school.klassen/classes.functions";
import type { TenantQueryKey } from "#/modules/util.fetch-client/tenant-query-key";
import type { ClassesSearch } from "./schema.search";

/**
 * Typed filter + pagination values for the klassen overview. Built from the page's typed
 * `Route.useSearch()` (component) or from the validated `location.search` (route loader) — both
 * feed the SAME query-options factory so the query key is identical for a given URL.
 */
export type KlassenOverviewFilters = ClassesSearch;

/** Follows the tenant segment — invalidate `[tenant, KLASSEN_OVERVIEW_QUERY_KEY]` to refresh every filter variant. */
export const KLASSEN_OVERVIEW_QUERY_KEY = "klassen-overview";

// See query.activities-overview for the SSR-without-hydration / staleTime rationale.
const OVERVIEW_STALE_TIME = 30_000;

export function klassenOverviewQueryOptions(
  tenant: TenantQueryKey,
  filters: KlassenOverviewFilters,
) {
  return queryOptions({
    // The server fn resolves the school from the page URL, not from `filters` — the tenant
    // segment is what keeps two schools' lists from colliding under one cache key.
    queryKey: [tenant, KLASSEN_OVERVIEW_QUERY_KEY, filters] as const,
    queryFn: () => getClassesOverview({ data: filters }),
    staleTime: OVERVIEW_STALE_TIME,
  });
}
